import React, { useMemo } from 'react';
import { useParams } from 'umi';
import { resolvePrCurrentGameDisplayName, type IPrGameChannelItem } from '../../_utils';
import './index.scss';

export interface IPrGameTitleProps {
  data?: Record<string, unknown>;
  prGamesChannels?: IPrGameChannelItem[];
}

/**
 * PR 工作台主内容区游戏标题（位于跑马灯上方，名称来自 games 接口 game_name）。
 */
const PrGameTitle: React.FC<IPrGameTitleProps> = (props) => {
  const { data, prGamesChannels } = props;
  const { gameCode } = useParams<{ gameCode?: string }>();
  const routeGame = (gameCode || '').trim();
  const fallbackGame = String(data?.prHubGameCode ?? '').trim();
  const effectiveHubCode = routeGame || fallbackGame;

  const title = useMemo(() => {
    const base = (data || {}) as Record<string, unknown>;
    return resolvePrCurrentGameDisplayName(
      { ...base, prHubGameCode: effectiveHubCode },
      prGamesChannels,
    );
  }, [data, prGamesChannels, effectiveHubCode]);

  if (!title) {
    return null;
  }

  return <h2 className="dbh-pr-game-title">{title}</h2>;
};

export default PrGameTitle;
